import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export const NotificationBell = ({ testId = "notif-bell" }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  const load = () => api.get("/notifications/me").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      await api.post("/notifications/read-all").catch(() => {});
      setItems((its) => its.map((n) => ({ ...n, read: true })));
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid={testId} onClick={toggle} className="relative text-white/80 hover:text-gold transition-colors p-1">
        <Bell size={20} />
        {unread > 0 && <span data-testid="notif-badge" className="absolute -top-1 -right-1 bg-gold text-white text-[10px] font-bold h-4 min-w-4 px-1 rounded-full flex items-center justify-center">{unread}</span>}
      </button>
      {open && (
        <div data-testid="notif-dropdown" className="absolute right-0 mt-2 w-80 bg-white border border-border shadow-xl z-50 text-navy">
          <div className="px-4 py-3 border-b border-border font-heading text-lg">Notifications</div>
          <div className="max-h-80 overflow-y-auto">
            {items.length === 0 && <p className="p-4 text-sm text-muted-foreground text-center">Aucune notification.</p>}
            {items.map((n) => (
              <button key={n.id} onClick={() => { setOpen(false); if (n.link) navigate(n.link); }}
                className="w-full text-left px-4 py-3 border-b border-border hover:bg-[#F8F9FA] transition-colors">
                <p className="text-sm font-medium">{n.title}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>
                <p className="text-[10px] text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</p>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
